import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, gradient, skinOutline, fill, outline, secondaryFill }) {
  const randomGradientId1 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M108 41.87C108 41.87 80.37 27.42 78.97 25.66C77.57 23.9 76.63 1 76.63 1H54.62C54.62 1 53.68 23.9 52.28 25.66C50.88 27.42 23.25 41.87 23.25 41.87C23.25 41.87 35.49 56.92 65.62 56.92C95.75 56.92 108 41.87 108 41.87Z"
        fill={`url(#${randomGradientId1})`}
        stroke={skinOutline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M121.72 47.56C118.64 43.93 84.08 26.75 84.08 26.75L78.95 17.17L65.62 24.71L52.29 17.17L47.16 26.75C47.16 26.75 12.6 43.92 9.52 47.56C6.44 51.19 2 72.33 2 72.33H129.23C129.24 72.33 124.79 51.2 121.72 47.56Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M84.0799 26.7601L73.1399 38.3201L65.5699 25.1001L58.0999 38.3201L47.1699 26.7601"
        fill={fill}
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M66.4203 41.94L70.0604 34.01L65.6804 25.97L61.1804 34.01L64.8203 41.94L59.3604 71.36H71.8904L66.4203 41.94Z"
        fill={secondaryFill}
      />
      <path d="M38.8602 73.2701L34.3202 32.0601L29.4902 34.5101L33.9102 73.2701H38.8602Z" fill="#513019" />
      <path d="M92.9004 73.2701L97.4404 32.0601L102.28 34.5101L97.8604 73.2701H92.9004Z" fill="#513019" />
      <defs>
        <linearGradient
          id={randomGradientId1}
          x1="65.6222"
          y1="28.6261"
          x2="65.6222"
          y2="11.8864"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1476" stopColor={gradient[1]} />
          <stop offset="0.8447" stopColor={gradient[0]} />
        </linearGradient>
      </defs>
    </g>
  )
}
